export function Hero() {
  return (
    <section className="hero section" id="top">
      <div className="container hero-grid">
        <div>
          <div className="hero-tag">For SMBs · No tech team required</div>
          <h1 className="hero-title">
            Own the business. Don&rsquo;t be <em>owned</em> by it.
          </h1>
          <p className="hero-lead">
            We build the software that handles the work you shouldn&rsquo;t be doing
            &mdash; quoting, scheduling, paperwork, follow-ups &mdash; so the
            business runs whether you&rsquo;re on a job site, on a beach, or in bed.
            No tech jargon. No 80-page proposals. First system live in weeks.
          </p>

          <div className="hero-ctas">
            <a className="btn btn-primary" href="#inquiry">
              Get my free game plan <span className="arrow">→</span>
            </a>
            <a className="btn btn-ghost" href="#work">
              See what we&rsquo;ve built
            </a>
          </div>

          <div className="hero-trust">
            <span><i className="dot" /> First call is free &mdash; you leave with a plan either way</span>
            <span><i className="dot" /> Fixed scope. Fixed price.</span>
            <span><i className="dot" /> Built for SMBs without a tech team</span>
          </div>
        </div>

        <div className="hero-art" aria-hidden="true">
          <div className="hero-art-frame">
            <span className="hero-art-sticker s1">ship.it</span>
            <span className="hero-art-sticker s2">no.nights</span>
            <span className="hero-art-sticker s3">ROI&nbsp;++</span>
            <div className="hero-art-logo">
              <img src="/logo.png" alt="Tiny Cloud logo" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
